'use client'

import { Box } from '@mui/material'
import classNames from 'classnames'
import { StyledPageDivider } from './pageDivider.styles'
import { ArrowIcon } from '../icons/arrowIcon'

export const PageDivider = ({ className, ...props }) => {
  return (
    <StyledPageDivider className={classNames("page-divider", className)} {...props}>
      <Box className="lines" />
      <Box className="lines ghost" />
      <ArrowIcon className="arrow" />
    </StyledPageDivider>
  )
}
